import { render, staticRenderFns } from "./IncomingDocumentList.vue?vue&type=template&id=e90e5280&scoped=true&"
import script from "./IncomingDocumentList.vue?vue&type=script&lang=js&"
export * from "./IncomingDocumentList.vue?vue&type=script&lang=js&"
import style0 from "./IncomingDocumentList.vue?vue&type=style&index=0&id=e90e5280&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90e5280",
  null
  
)

export default component.exports